import ExamsListBuilder from "../../components/exam/ExamsListBuilder";
import ComponentCard from "../../components/common/ComponentCard";
import SliderListComponent from "../../components/slider/SliderListComponent";
import React from "react";
import PageMeta from "../../components/common/PageMeta";

export default function ExamsList() {
    return (
        <>
            <PageMeta title="Danh sách bài thi" description="Danh sách bài thi"/>
            <div className="space-y-6">
                <ComponentCard title="">
                    <ExamsListBuilder />
                </ComponentCard>
            </div>
        </>
    );
}
